module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M0 8v22c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V8H0zm24 15a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2zm0-6a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2zm8-15c0-1.106-.894-2-2-2H2C.894 0 0 .894 0 2v4h32V2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/notepad-1.js
// module id = 1310
// module chunks = 14